import { env } from '@monorepo/env'
import { GoogleSignin } from '@react-native-google-signin/google-signin'
import { Platform } from 'react-native'

export const configureGoogleSignin = () => {
  if (Platform.OS === 'web') {
    // Web doesn't need GoogleSignin configuration
    return
  }

  try {
    const webClientId = env.EXPO_PUBLIC_FIREBASE_IOS_CLIENT_ID

    if (!webClientId) {
      return
    }

    GoogleSignin.configure({
      webClientId: webClientId,
      offlineAccess: true,
      forceCodeForRefreshToken: true,
      profileImageSize: 120,
    })

    console.log('[Google Sign-in] Configured successfully')
  } catch (error) {
    console.error('[Google Sign-in] Configuration failed:', error)
  }
}
